import { useEffect, useState } from "react";
import { useLanguage } from "@/i18n/LanguageContext";

const TARGET = new Date("2026-10-15T09:00:00+02:00").getTime();

const calc = () => {
  const diff = Math.max(0, TARGET - Date.now());
  const days = Math.floor(diff / 86400000);
  const hours = Math.floor((diff % 86400000) / 3600000);
  const minutes = Math.floor((diff % 3600000) / 60000);
  const seconds = Math.floor((diff % 60000) / 1000);
  return { days, hours, minutes, seconds };
};

export const Countdown = () => {
  const { t } = useLanguage();
  const c = t.hero.countdown;
  const [time, setTime] = useState(calc());

  useEffect(() => {
    const id = setInterval(() => setTime(calc()), 1000);
    return () => clearInterval(id);
  }, []);

  const units = [
    { value: time.days, label: c.days },
    { value: time.hours, label: c.hours },
    { value: time.minutes, label: c.minutes },
    { value: time.seconds, label: c.seconds },
  ];

  return (
    <div data-testid="hero-countdown" className="flex flex-col items-center">
      <div className="overline text-[#CEA26B] mb-3 text-center">{t.hero.countdownTitle}</div>
      <div className="flex gap-3 sm:gap-4">
        {units.map((u, i) => (
          <div
            key={i}
            className="flex flex-col items-center border border-white/10 bg-white/[0.03] backdrop-blur-sm px-4 py-3 sm:px-5 sm:py-4 min-w-[68px] sm:min-w-[80px]"
            data-testid={`countdown-unit-${i}`}
          >
            <span className="font-display font-black text-white text-2xl sm:text-3xl tabular-nums leading-none">
              {String(u.value).padStart(2, "0")}
            </span>
            <span className="mt-2 text-[10px] sm:text-xs uppercase tracking-[0.15em] text-slate-400">
              {u.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
